// extracted by mini-css-extract-plugin
module.exports = {"products":"Products_products__2QN7T","head":"Products_head__3Pj5z","title":"Products_title__1rrDP","wrapper":"Products_wrapper__3Ieqb"};